// extracted by mini-css-extract-plugin
export var body = "_gn-0";
export var sectionHeader = "_gn-4";
export var shortcutColumns = "_gn-2";
export var shortcutList = "_gn-1";
export var shortcutSection = "_gn-3";